const withAdContextData = (adSpot) => {
  return {
    media_ads: {
      schema: 'iglu:au.com.realestate/media_ads/jsonschema/1-0-2',
      data: {
        platform: adSpot.params.platform,
        site: adSpot.config.abbreviatedSite,
        section: adSpot.params.sect,
        channel: adSpot.params.channel,
        position: adSpot.params.pos,
        app_source: adSpot.appName,
        group_id: adSpot.guid,
      },
    },
  };
};

export default withAdContextData;
